import {
    LOG_OUT, COMPENSATION_SETTING, GET_CURRENT_COMP_PROFILE, COMP_PERIOD_BATCH,
    GET_COMMISSION_REPORT, GET_COMP_AGREEMENT, GET_PERFORMANCE_REPORT, 
    GET_KPI_EXPLANATION_REPORT, GET_KPI_EXPLANATION_BATCH_REPORT,
    GET_ACTIVITY_REPORT, GET_ACTIVITY_DATA_LIST
} from "./ActionTypes";

import {axiosInstanceWithToken}  from "../utils/Client";
import ReportService from "../services/ReportService";
import CompensationProfileService from "../services/CompensationProfileService";
import {getUser} from "../utils/TokenManager";


const logOutSuccess = () => ({type: LOG_OUT});

const setCompensationSetting = (compensation) => ({type: COMPENSATION_SETTING, compensation});


export const getCompensationKPI = (compensationProfileId) => (
    async (dispatch) => {
        try {
            const result = await CompensationProfileService.compensationKpi(compensationProfileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data.compensation_kpi;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const compensationList = (selectedUserId) => (
    async (dispatch) => {
        try {
            const result = await CompensationProfileService.compensationList(selectedUserId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data.compensation_profile;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getCompensationPeriodList = (compProfileId) => (
    async (dispatch) => {
        try {
            const result = await ReportService.getCompensationPeriods(compProfileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getCompensationIncomes = (compProfileId) => (
    async (dispatch) => {
        try {
            const result = await ReportService.getCompensationIncomes(compProfileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const compensationPayments = (compProfileId, compensationPaymentList, method) => (
    async (dispatch) => {
        try {
            let result;
            if (method === "GET") {
                result = await ReportService.getCompensationPayments(compProfileId);
            } else {
                result = await ReportService.updateCompensationPayments(compProfileId, compensationPaymentList);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const revenueActual = (compProfileId, revenueActualData, method) => (
    async (dispatch) => {
        try {
            let result;
            if (method === "GET") {
                result = await ReportService.getRevenueActual(compProfileId);
            } else {
                result = await ReportService.updateRevenueActual(compProfileId, revenueActualData);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const compensationSetting = (compProfileId, data, method) => (
    async (dispatch) => {
        try {
            let result;
            if (method === "GET") {
                result = await ReportService.getCompensationSetting(compProfileId);
            } else {
                result = await ReportService.updateCompensationSetting(compProfileId, data);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch(setCompensationSetting({...result.data}));
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const revenueGoal = (compProfileId, revenueGoalData, method) => (
    async (dispatch) => {
        try {
            let result;
            if (method === "GET") {
                result = await ReportService.getRevenueGoal(compProfileId);
            } else {
                result = await ReportService.updateRevenueGoal(compProfileId, revenueGoalData);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getKPIDataList = (
    agencyLocation, fromDate, toDate, kpiIdList, userIdList, dataType
) => (
    async (dispatch) => {
        try {
            const result = await ReportService.getKPIDataList(
                agencyLocation, fromDate, toDate, kpiIdList, userIdList, dataType
            );
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getUserList = () => (
    async (dispatch) => {
        try {
            let result = await ReportService.getUserList();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result.data.user;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);


export const ReportAction = (action) => (
    async (dispatch) => {
        try {
            let result;
            switch (action.type) {
                case GET_CURRENT_COMP_PROFILE: {
                    result = await axiosInstanceWithToken.get(`/compensation/active/profile/`);
                    break;
                }
                case COMP_PERIOD_BATCH: {
                    result = await axiosInstanceWithToken.get(
                        `/report/user/periods/${action.agencyLocation}/`
                    );
                    break;
                }
                case GET_COMMISSION_REPORT: {
                    result = await axiosInstanceWithToken.post(
                        `/report/commission/`, 
                        {
                            profile_list: action.compProfileList,
                            report_date: action.reviewDate
                        }
                    );
                    break;
                }
                case GET_COMP_AGREEMENT: {
                    result = await axiosInstanceWithToken.post(
                        `/report/compensation_agreement/`, 
                        {
                            profile_list: action.compProfileList,
                            review_date: action.reviewDate
                        }
                    );
                    break;
                }
                case GET_PERFORMANCE_REPORT: {
                    result = await axiosInstanceWithToken.post(
                        `/report/performance_evaluation/`, 
                        {
                            period_list: action.compPeriodList,
                            review_date: action.reviewDate
                        }
                    );
                    break;
                }
                case GET_KPI_EXPLANATION_REPORT: {
                    let url = `/report/kpi_explanations/`;
                    result = await axiosInstanceWithToken.get(
                        `${url}?kpi_list=[${
                            action.kpiList
                        }]&staff_name=${
                            action.staffName
                        }&compensation_date_range=${action.dateRange}`
                    );
                    break;
                }
                case GET_KPI_EXPLANATION_BATCH_REPORT: {
                    result = await axiosInstanceWithToken.post(
                        `/report/kpi_explanations/batch/`, {
                            profile_list: action.compProfileList,
                        }
                    );
                    break;
                }
                case GET_ACTIVITY_DATA_LIST: {
                    result = await axiosInstanceWithToken.get(
                        `/report/activity_data/list/?start_date=${action.fromDate}&end_date=${action.toDate}`
                    );
                    break;
                }
                case GET_ACTIVITY_REPORT: {
                    result = await axiosInstanceWithToken.get(
                        `/report/activity_data/?start_date=${action.fromDate}&end_date=${action.toDate}`
                    );
                    break;
                }

                default:
                    result = await axiosInstanceWithToken.get(
                        `/compensation/active/profile/`
                    );
            }
            
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status || 201 === result.status) {
                dispatch({...action, response: result.data});
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/ReportAction.js